import { useEffect, useMemo, useState } from 'react'
import { FaArrowRightLong } from 'react-icons/fa6'
import { NavLink } from 'react-router-dom'
import FortuneBasketCard from '../UI/FortuneBasketCard'
import { compareProductSortOrder, fetchProducts } from '../../api/productApi'

const FortuneBasket = () => {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false

    async function loadProducts() {
      setLoading(true)
      setError('')
      try {
        const data = await fetchProducts()
        if (!cancelled) setProducts(data)
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load products')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    loadProducts()
    return () => {
      cancelled = true
    }
  }, [])

  const orderedProducts = useMemo(
    () => [...products].sort(compareProductSortOrder),
    [products]
  )

  return (
    <section className="space-top">
      <div className="container">
        <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
          <div>
            <h2 className="fw-semibold text-lora">Your Fortune Basket</h2>
            <p className="light-color mb-0">
              A collection of personalised remedies, reports, and tools aligned
              with your cosmic journey.
            </p>
          </div>
          <NavLink
            className="no-underline text-dark flex-shrink-0"
            to="/shop"
          >
            View All <FaArrowRightLong className="ms-2 d-inline" />
          </NavLink>
        </div>

        {loading && <p className="text-center py-4">Loading products...</p>}
        {error && !loading && (
          <p className="text-center py-4 text-danger">{error}</p>
        )}
        {!loading && !error && orderedProducts.length === 0 && (
          <p className="text-center py-4">No products available right now.</p>
        )}
        {!loading && !error && orderedProducts.length > 0 && (
          <div className="row g-3 flex-nowrap overflow-auto fortune-scroll-row pb-2">
            {orderedProducts.map((item) => (
              <div
                className="col-10 col-sm-6 col-md-4 col-lg-3"
                key={item.product_id}
              >
                <FortuneBasketCard item={item} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default FortuneBasket
